(function () {
    'use strict';
    angular
        .module('app')
        .directive('msgBox', msgBox);
    msgBox.$inject = ['$window', '$rootScope', '$timeout', '$mdDialog'];
    function msgBox($window, $rootScope, $timeout, $mdDialog) {
        var directive = {
            link: link,
            restrict: 'EA',
            //scope: {
            //    msgBoxShown: '=?'
            //},
            //controller: 'msgBox',
            templateUrl: 'app/msgBox/msgBox.html'
        };
        return directive;
        function link(scope, element, attrs) {

            // Init.
            $rootScope.msgBox = {};
            $rootScope.msgBox.visible = false;

            $rootScope.msgBoxClosed = function () {
                //msgBox.visible = false;
                $rootScope.msgBox.visible = false;
                $rootScope.lastAction();
            }

            $rootScope.closeMsgBox = function () {
                $rootScope.msgBox.visible = false;
            }

            // Using rootScope so that this function is available from anywhere.
            $rootScope.msgBoxShow = function (message, title, type, bNoIndent, duration) {

                var elem = document.getElementById("msgBoxId");
                if (elem != null) {
                    if (type == 1) {
                        // Info - green
                        elem.style.backgroundColor = "#bae8aa";
                        elem.style.color = "#3c763d";
                    }
                    else if (type == 2) {
                        // Warning - Yellow/orange
                        elem.className.replace(" alert-danger", "");
                        elem.className += " alert-warning";
                    }
                    else {
                        elem.className.replace(" alert-warning", "");
                        elem.className += " alert-danger";
                    }
                }

                // Use white space style to handle indent. 
                // Default is paragraph form with an indent on the first line.
                // With no indent, all lines are at the left margin.
                if (bNoIndent)
                    $rootScope.msgBox.whiteSpace = "pre-line";
                else
                    $rootScope.msgBox.whiteSpace = "pre";

                // Set vars for this instance.
                $rootScope.msgBox.message = message;
                $rootScope.msgBox.title = title;
                $rootScope.msgBox.visible = true;

                // If doing a toast (pop-up) message, it will go away on its own.
                if (type == 1 || duration) {
                    var timeout = 3000;

                    if (duration) {
                        timeout = duration;
                    }

                    $timeout(function () {
                        $rootScope.msgBox.visible = false;
                    }, timeout)
                }
            }

            // Using rootScope so that this function is available from anywhere.
            $rootScope.inputBoxShow = function (param1, param2, title, prompt1, prompt2, edit1, edit2, preClosePromiseCallback, postCloseCallback) {
                // Set vars for this instance.
                $rootScope.inputBox = {};
                $rootScope.inputBox.param1 = param1;
                $rootScope.inputBox.param2 = param2;
                $rootScope.inputBox.title = title;
                $rootScope.inputBox.prompt1 = prompt1;
                $rootScope.inputBox.prompt2 = prompt2;
                $rootScope.inputBox.edit1 = edit1;
                $rootScope.inputBox.edit2 = edit2;
                $rootScope.inputBox.visible = true;
                $rootScope.inputBox.preClosePromiseCallback = preClosePromiseCallback;
                $rootScope.inputBox.postCloseCallback = postCloseCallback;
                // Open the dialog.
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/msgBox/inputBox.html',
                    controller: 'inputBox',
                    fullscreen: false//,
                    //locals: {
                    //records: service.records,
                    //command: command
                    //}
                });
            }

            // Using rootScope so that this function is available from anywhere.
            $rootScope.confirmBoxShow = function (param1, param2, title, prompt1, prompt2, postCloseCallback) {
                // Set vars for this instance.
                $rootScope.confirmBox = {};
                $rootScope.confirmBox.param1 = param1;
                $rootScope.confirmBox.param2 = param2;
                $rootScope.confirmBox.title = title;
                $rootScope.confirmBox.prompt1 = prompt1;
                $rootScope.confirmBox.prompt2 = prompt2;
                $rootScope.confirmBox.postCloseCallback = postCloseCallback;
                // Open the dialog.
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/msgBox/confirmBox.html',
                    controller: 'confirmBox',
                    fullscreen: false,
                    //locals: {
                    //records: service.records,
                    //command: command
                    //}
                    skipHide: true
                });
            }

            $rootScope.yesNoCancelBoxShow = function (param1, param2, title, prompt1, prompt2, postCloseCallback) {
                // Set vars for this instance.
                $rootScope.yesNoCancelBox = {};
                $rootScope.yesNoCancelBox.param1 = param1;
                $rootScope.yesNoCancelBox.param2 = param2;
                $rootScope.yesNoCancelBox.title = title;
                $rootScope.yesNoCancelBox.prompt1 = prompt1;
                $rootScope.yesNoCancelBox.prompt2 = prompt2;
                $rootScope.yesNoCancelBox.postCloseCallback = postCloseCallback;
                // Open the dialog.
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/msgBox/yesNoCancelBox.html',
                    controller: 'yesNoCancelBox',
                    fullscreen: false,
                    //locals: {
                    //records: service.records,
                    //command: command
                    //}
                    skipHide: true
                });
            }


            // Using rootScope so that this function is available from anywhere.
            $rootScope.browseFolderBoxShow = function (param1, param2, title, prompt1, prompt2, edit1, driveType, edit2, initialPath, 
                preClosePromiseCallback, postCloseCallback, edit2length, continueOnAccessFailure) {
                // Set vars for this instance.
                $rootScope.browseFolderBox = {};
                $rootScope.browseFolderBox.param1 = param1;
                $rootScope.browseFolderBox.param2 = param2;
                $rootScope.browseFolderBox.title = title;
                $rootScope.browseFolderBox.prompt1 = prompt1;
                $rootScope.browseFolderBox.prompt2 = prompt2;
                $rootScope.browseFolderBox.edit1 = edit1;
                $rootScope.browseFolderBox.driveType = driveType;
                $rootScope.browseFolderBox.edit2 = edit2;
                $rootScope.browseFolderBox.edit2length = 64;
                $rootScope.browseFolderBox.initialPath = initialPath;
                $rootScope.browseFolderBox.preClosePromiseCallback = preClosePromiseCallback;
                $rootScope.browseFolderBox.postCloseCallback = postCloseCallback;
                $rootScope.browseFolderBox.continueOnAccessFailure = continueOnAccessFailure;
                // Open the dialog.
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/msgBox/browseFolderBox.html',
                    controller: 'browseFolderBox',
                    fullscreen: false,
                    //locals: {
                    //records: service.records,
                    //command: command
                    //}
                    skipHide: true
                });
            }

            // Using rootScope so that this function is available from anywhere.
            $rootScope.questionBoxShow = function (param1, param2, title, prompt1, prompt2, postCloseCallback) {
                // Set vars for this instance.
                $rootScope.questionBox = {};
                $rootScope.questionBox.param1 = param1;
                $rootScope.questionBox.param2 = param2;
                $rootScope.questionBox.title = title;
                $rootScope.questionBox.prompt1 = prompt1;
                $rootScope.questionBox.prompt2 = prompt2;
                $rootScope.questionBox.postCloseCallback = postCloseCallback;
                // Open the dialog.
                $mdDialog.show({
                    parent: angular.element(document.body),
                    templateUrl: 'app/msgBox/questionBox.html',
                    controller: 'questionBox',
                    fullscreen: false,
                    //locals: {
                    //records: service.records,
                    //command: command
                    //}
                    skipHide: true
                });
            }

        }
    }
})();